import { useParams  , useLocation } from "react-router-dom";
import { useCustomHistory } from "hooks";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { CustomButton } from "components/Button";
import { TranslationText } from "components/TextTranslationContainer";
const TrackOrderFooter = ({ orderInfo }) => {
  const params = useParams();
  const router = useCustomHistory();
  const location = useLocation();
    const { DomainType } = useSelector((state) => state.AppReducer);
  const CareemTracking = () => {
    window.open(orderInfo?.careem_delivery?.tracking_url, "_blank");
  }
  
  const JeeblyTracking = () => {
    const url = "/track-order-jeebly/";
    router(
      `${url}${params?.orderId}`,
      `/${params.domainName}${url}${params?.orderId}`,
      DomainType
    );
  };

  
  const SliderTracking = () => {
    const url = "/track-order-slider/";
    router(
      `${url}${params?.orderId}`,
      `/${params.domainName}${url}${params?.orderId}`,
      DomainType
    );
  };


  const isJeeblyTrackPage = /\/track-order-jeebly\/[^/]+$/.test(location.pathname);
  const isSliderTrackPage = /\/track-order-slider\/[^/]+$/.test(location.pathname);


  return (
    <>
    
      {/* careem-delivery */}
      {orderInfo?.careem_delivery?.tracking_url && (
        <CustomButton
        onClick={CareemTracking}
        outline={true}
        className="w-full"
        >
          <TranslationText text={t("Track Driver")} />
        </CustomButton>
      )}
      {/* jeebly-delivery */}
      {orderInfo?.jeebly_delivery && !isJeeblyTrackPage && (
        <CustomButton
        onClick={JeeblyTracking}
        outline={true}
        className="w-full"
        >
          <TranslationText text={t("Track Driver")} />
        </CustomButton>
        
      )}
      {/* slider-delivery */}
      {orderInfo?.slider_delivery && !isSliderTrackPage && (
        <CustomButton
        onClick={SliderTracking}
        outline={true}
        className="w-full"
        >
          <TranslationText text={t("Track Driver")} />
        </CustomButton>
        
      )}
     
    </>
  );
};

export default TrackOrderFooter;
